import IconViverseLogo from '@/components/assets/icon_viverse_logo.svg'
import { Link } from '@/i18n/navigation'
import { getWorldsDomain } from '@/lib/configs'
import { LogoPosition } from '@/services/cms'
import { motion } from 'framer-motion'
import { usePathname } from 'next/navigation'

type ViverseLogoOverlayProps = {
  isVisible: boolean
  position?: LogoPosition
}
const positionClassNames: Record<string, string> = {
  'top-left': 'top-4 left-5',
  'top-center': 'top-4 left-1/2 -translate-x-1/2',
  'top-right': 'top-4 right-5',
  'bottom-left': 'bottom-4 left-5',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2',
  'bottom-right': 'bottom-4 right-5',
}

const isParentDomainAllowed = () => {
  if (window.parent === window) return true

  const ancestorOrigin = window.location.ancestorOrigins?.[0]
  if (ancestorOrigin) {
    return new URL(ancestorOrigin).hostname === getWorldsDomain()
  }
  if (!document.referrer) {
    return false
  }

  return new URL(document.referrer).hostname === getWorldsDomain()
}

const ViverseLogoOverlay = ({ position = 'top-left', isVisible }: ViverseLogoOverlayProps) => {
  const pathname = usePathname()
  if (!isVisible) return null
  const parentAllowed = isParentDomainAllowed()

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{
        opacity: isVisible ? 1 : 0,
      }}
      transition={{
        duration: 0.6,
        ease: [0.4, 0, 0.2, 1],
      }}
      className={`absolute z-20 ${positionClassNames[position]} ${!parentAllowed ? 'cursor-pointer' : ''}`}
    >
      {!parentAllowed ? (
        <Link href={pathname} target="_blank">
          <IconViverseLogo width={154} height={24} />
        </Link>
      ) : (
        <IconViverseLogo width={154} height={24} />
      )}
    </motion.div>
  )
}

export default ViverseLogoOverlay
